<script>
    import Statusbar from "./statusbar.vue";

    export default {
        name: "application-footer",
        components: {Statusbar},
        props: {
            version: String,
            year: String,
            esign: String,
            normalUser: Boolean,
            incompleteSettings: Boolean
        },
        computed: {
            translations() {
                return {
                   ewi: Lang.langGet('EWI')
                }
            },
            footnote() {
                const webinterface = Lang.langGet('Webinterface');
                return `easescreen ${webinterface} ${this.version} © 2016 - ${this.year}`;
            }
        }
    }
</script>

<template>
    <v-footer class="d-flex flex-row justify-space-between" elevation="4" id="app-footer" >
        <a href="https://easescreen.com" target="_blank" style="target-new: tab;color: var(--color-easescreen-primary);">
            <img style="height: 16px" src="/img/logo-easescreen.svg" :alt="translations.ewi"/>
            {{ footnote }}
        </a>
        <statusbar
            :esign="esign === '1'"
            :normal-user="normalUser"
            :incomplete-settings="incompleteSettings"
        >
            <custom-settings/>
        </statusbar>
    </v-footer>
</template>
